import forge from "node-forge";

const encrypt = async (message: string): Promise<{ iv: string; encryptedAESKey: string; encryptedMessage: string; authTag: string } | null> => {
 
  try {
   
    const publicKeyPem = (process.env.REACT_APP_ENCRYPTION_PUBLIC_KEY as string).replace(/\\n/g, "\n");
 
    if (!publicKeyPem) {
      throw new Error("Public key not found in environment variables");
    }
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

 
    const aesKey = forge.random.getBytesSync(32); 
    const iv = forge.random.getBytesSync(16);

 
    const cipher = forge.cipher.createCipher("AES-GCM", aesKey);
    cipher.start({ iv });
    cipher.update(forge.util.createBuffer(message, "utf8"));
    cipher.finish();
    const encryptedMessage = cipher.output.getBytes();
    const authTag = cipher.mode.tag.getBytes(); 

   
    const encryptedAESKey = publicKey.encrypt(aesKey, "RSA-OAEP", {
      md: forge.md.sha256.create(),
    });

  
    return {
      iv: forge.util.encode64(iv),
      encryptedAESKey: forge.util.encode64(encryptedAESKey),
      encryptedMessage: forge.util.encode64(encryptedMessage),
      authTag: forge.util.encode64(authTag), 
    };
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error("Encryption failed:", error.message);
    } else {
      console.error("Encryption failed with an unknown error:", error);
    }
    return null;
  }
};

export default encrypt;
